/** Shape of a single `{ value, label }` entry served by `GET /api/enums/audit-actions`. */
export type LabeledValuePayload = {
	readonly value: string;
	readonly label: string;
};

export type AuditActionsFetchedPayload = LabeledValuePayload[];

export type AuditActionsFetchedAction = {
	type: 'AUDIT_ACTIONS_FETCHED';
	payload: AuditActionsFetchedPayload;
};

export default (payload: AuditActionsFetchedPayload): AuditActionsFetchedAction => ({
	type: 'AUDIT_ACTIONS_FETCHED',
	payload,
});
